<template>
<update-base>
    <div>
        <div v-if="has_error" v-text="error_text" class="alert alert-danger mb-4"></div>
        <div v-if="is_updated" class="alert alert-success mb-4" v-text="successful_update_text"></div>
        <div class="d-flex align-items-center justify-content-between">
            <div class="w-50">
                <label for="add_stakeholder" v-text="$t('stakeholders.label.add_stakeholder_to_allotment')"></label>
                <select id="add_stakeholder"
                        name="add_stakeholder"
                        v-model="new_stakeholder"
                        @change="open_add_new_allotment_modal()"
                        class="form-control kt-selectpicker">
                    <option v-for="(item, index) in enabled_stakeholders" :key="index" :value="item">
                        <span>{{ item.full_name }} ({{ resolve_id(item.id) }})</span>
                    </option>
                </select>
            </div>
            <div>
                <button type="button"
                        class="btn btn-success ml-3"
                        id="submit_allotment_btn"
                        @click="submit_allotment()"
                        v-text="$t('btn.submit_changes')">
                </button>
                <button type="button"
                        class="btn btn-danger"
                        id="delete_all_button"
                        @click="delete_allotments()"
                        v-text="$t('btn.delete_all')">
                </button>
            </div>
        </div>
        <div class="line-divider mt-4 mb-3"></div>
        <div class="text-center">
            <table class="table">
                <thead>
                    <tr>
                        <th v-text="$t('label.identifier')" class="bg-white"></th>
                        <th v-text="$t('label.full_name')" class="bg-white"></th>
                        <th v-text="$t('label.sheba_number')" class="bg-white"></th>
                        <th v-text="$t('label.percent')" class="bg-white"></th>
                        <th v-text="$t('datatable.actions')" class="bg-white"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in allotments" :key="index">
                        <td v-text="resolve_id(item.id)"></td>
                        <td v-text="item.full_name"></td>
                        <td v-text="item.sheba_number.number"></td>
                        <td v-text="item.percent"></td>
                        <td>
                            <button type="button" class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm" @click="deleteRow(index)">
                                <span class="tooltip-text">حذف</span>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#ff6060"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"/></svg>
                                </span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr style="border-top: 1px solid #dedede;margin-top: 50px!important;" class="my-4" />
        <form id="update_settlement_sheba_form">
            <div style="" class="d-flex align-items-center justify-content-between">
                <div class="w-50">
                    <label for="merchant_sheba_select" v-text="$t('label.main_iban_sheba')"></label>
                    <div>
                        <label for="iban_id" v-text="main_iban"></label>
                        <select id="iban_id"
                                name="iban_id"
                                v-model="selected_sheba"
                                @change="on_sheba_change()"
                                class="form-control kt-selectpicker">
                            <option v-for="item in iban_list" :key="item.id" :value="item">
                                {{ item.number }} - {{ $t('label.percent') }}:
                                {{ allotments.length === 0 ? 100 : sheba_remaining_percent }}%
                            </option>
                        </select>
                    </div>
                </div>
                <div style="padding-bottom: 50px">
                    <button type="button"
                            id="updateSettlementIbanBTN"
                            class="btn btn-success ml-3"
                            @click="updateSettlementIban()"
                            v-text="$t('btn.submit_changes')">
                    </button>
                </div>
            </div>
        </form>
        <div class="modal fade" id="add_new_allotment_modal" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <form @submit.prevent="add_new_allotment()" id="add_new_stakeholder_form">
                            <div v-if="new_stakeholder != null" class="row">
                                <div class="col-12 col-md-9 my-2">
                                    <label for="sheba" v-text="$t('label.sheba_number')"></label>
                                    <select id="sheba"
                                            name="sheba"
                                            v-model="new_sheba_details"
                                            class="form-control">
                                        <option v-for="(item, index) in new_stakeholder.sheba_numbers" :key="index" :value="item">
                                            <span v-text="item.number"></span>
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3 my-2">
                                    <label for="percent" v-text="$t('label.percent')"></label>
                                    <input  id="percent"
                                            name="percent"
                                            v-model="new_percent"
                                            class="form-control">
                                </div>
                            </div>
                            <div>
                                <button type="button" class="mx-2 btn btn-secondary" @click="reset_new_stakeholder()" data-dismiss="modal" v-text="$t('label.cancel')"></button>
                                <button type="submit" class="mx-2 btn btn-primary" v-text="$t('btn.add')"></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


    </div>
</update-base>
</template>

<script>
import UpdateBase from '../components/allotment-update-base';
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import { stakeholdersService, allotmentService, gatewayService } from '@/common/api.service';
import { merchantType, merchantTypeStr } from '@/constants/merchantType';
import { allotmentStatus } from '@/constants/AllotmentStatus';
import { mapGetters } from 'vuex';
import {KTApp} from '@/plugins/core/app'

export default {
    components: {
        UpdateBase,
    },
    data() {
        return {
            acceptor: null,
            current_user: this.$store.state.user.current_user,
            is_updated: false,
            successful_update_text: '',
            allotment_status: allotmentStatus,
            has_error: false,
            error_text: '',
            allotments: [],
            enabled_stakeholders: [],
            new_stakeholder: null,
            new_sheba_details: {
                id: null,
                number: '',
            },
            new_percent: 1,
            merchant_type: merchantType,
            merchant_type_str: merchantTypeStr,
            selected_sheba: null,
            sheba_remaining_percent: 100,
            main_iban: null,
        };
    },
    computed: {
        sum_of_percents() {
            return this.allotments.reduce((sum, item) => sum + item.percent, 0);
        },
        ...mapGetters('shebaNumber', ['iban_list']),
        
        hashid() {
            return this.$route.params.hashid;
        }
    },
    methods: {
        reset_new_stakeholder() {
            this.new_stakeholder = null;
        },
        open_add_new_allotment_modal() {
            $('#add_new_allotment_modal').modal('toggle');
        },
        delete_allotments() {
            if (window.confirm(i18n.t('message.delete_all_allotment_confirm'))) {
                this.has_error = false;
                this.error_text = '';
                this.allotments = [];
                this.calculate_sheba_percent();
            }
        },
        resolve_id(id) {
            return id === this.acceptor ? i18n.t('label.acceptor') : id;
        },
        submit_allotment() {
            let btn = $('#submit_allotment_btn')
            const allotments = this.allotments.map(item => ({
                ...(item.id === this.acceptor ? { acceptor: true } : { related_merchant_id: item.id }),
                percent: item.percent,
                sheba_number_id: item.sheba_number.id,
            }));

            const params = {
                allotments,
                allotment_status: allotments.length > 0
                    ? this.allotment_status.ACTIVE
                    : this.allotment_status.INACTIVE,
            };
            KTApp.progress(btn)
            allotmentService.update(this.$route.params.hashid, params).then(response => {
                this.successful_update_text = response.data.message;
                this.has_error = false;
                this.is_updated = true;
                this.calculate_sheba_percent();
            }).catch(({response}) => {
                this.is_updated = false;
                this.error_text = i18n.t('message.an_error_occurred');
                if (response.data && response.data.message) {
                    this.error_text = response.data.message;
                }
                this.has_error = true;
            }).finally(response => {
                KTApp.unprogress(btn)
            });
        },
        updateSettlementIban() {
            let btn = $('#updateSettlementIbanBTN')
            const form = $('#update_settlement_sheba_form');
            form.validate({
                rules: {
                    iban_id:   { required: true },
                },
            });
            if (!form.valid()) {
                return;
            }

            const sheba = this.selected_sheba.id;
            KTApp.progress(btn)
            gatewayService.updateSettlementIban(this.hashid, sheba).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data);
                }
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTApp.unprogress(btn)
            });
        },
        add_new_allotment() {
            if (!this.new_stakeholder) return;

            const form = $('#add_new_stakeholder_form');

            form.validate({
                rules: {
                    percent: { required: true, min: 1, max: () => 100 - this.sum_of_percents },
                    sheba:   { required: true },
                },
            });

            if (!form.valid()) {
                form.off('.validate').removeData('validator').removeData('unobtrusiveValidation');
                this.reset_new_stakeholder();
                return;
            }

            if (this.allotments.length >= 9) {
                this.error_text = i18n.t('stakeholders.error.max_allowed_stakeholders_for_allotment_list_are_nine');
                this.has_error = true;
                $('#add_new_allotment_modal').modal('toggle');
                this.reset_new_stakeholder();
                return;
            }

            if (this.allotments.some(
                a => a.id === this.new_stakeholder.id &&
                     a.sheba_number.number === this.new_sheba_details.number
            )) {
                this.error_text = i18n.t('stakeholders.error.cant_add_stakeholder_again');
                this.has_error = true;
                $('#add_new_allotment_modal').modal('toggle');
                this.reset_new_stakeholder();
                return;
            }

            this.allotments.push({
                full_name:    this.new_stakeholder.full_name,
                id:           this.new_stakeholder.id,
                sheba_number: this.new_sheba_details,
                percent:      parseFloat(this.new_percent),
            });

            this.calculate_sheba_percent();

            $('#add_new_allotment_modal').modal('toggle');
            this.new_sheba_details = { id: null, number: '' };
            this.new_percent = 1;
            this.reset_new_stakeholder();
        },
        deleteRow(index) {
            this.allotments.splice(index, 1);
            this.calculate_sheba_percent();
        },

        on_sheba_change() {
            this.calculate_sheba_percent();
        },

        init_select_picker() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText:  i18n.t('selectpicker.none_result'),
                    selectAllText:    i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected'),
                });
            }, 2000);
        },
        calculate_sheba_percent() {
            this.sheba_remaining_percent = Math.max(0, 100 - this.sum_of_percents);
        },
    },

    mounted() {
        const shebaParams = {
            hashid:    this.$route.params.hashid,
            shop_type: 1,
        };
        if (this.iban_list.length > 0) {
            this.selected_sheba = this.main_iban;
        }

        this.$store.dispatch('shebaNumber/fetchIbanList', shebaParams).then(() => {
            this.calculate_sheba_percent();
        });

        gatewayService.find(this.$route.params.hashid).then(response => {
            const match = this.iban_list.find(item => item.id === response.data.data.sheba);
            this.main_iban = match ? match.number : null;
        })

        stakeholdersService.get_shop_enabled_stakeholders(this.$route.params.hashid).then(response => {
            this.enabled_stakeholders = response.data.data;

            gatewayService.getGatewayShebaNumbers(this.$route.params.hashid).then(res => {
                this.enabled_stakeholders.push({
                    id:            this.acceptor,
                    full_name:     res.data.data.full_name,
                    sheba_numbers: res.data.data.sheba_numbers,
                });

                allotmentService.fetch(this.$route.params.hashid).then(response => {
                    this.allotments = response.data.data;
                    this.calculate_sheba_percent();
                });
            }).finally(() => {
                this.init_select_picker();
            });
        });
    },

    watch: {
        sheba_remaining_percent(newVal) {
            this.$nextTick(() => {
                $('#merchant_sheba_select').selectpicker('refresh');
            });
        },
    },
};
</script>

<style scoped>
#delete_all_button {
    background-color: #ff6060 !important;
    border-color: #ff6060 !important;
}
#delete_all_button:hover {
    color: #ff6060 !important;
    background-color: transparent !important;
    border-color: #ff6060 !important;
}
.sheba-section {
    margin-top: 2rem;
}
</style>